export default __webpack_public_path__ + "static/media/Old-Portfolio.aaae9688.jpg";